<template>
    <v-card min-width="20vw" max-width="30vw" align="center" justify="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title class="d-flex justify-center"><v-icon class="mr-2 ">fa-regular fa-bolt</v-icon><h2 style="color: #111111">
                  {{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon @click="closeWindow" class="icon" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p>{{ message }}</p>
            <p >{{ $t('callToActionText') }}</p>
            <v-btn @click="upgrade">{{ $t('btnUpgrade') }} »</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "UpgradeToPro",
        props: {
            message: String,
        },
        methods: {
            closeWindow() {
                this.$emit('closeWindow');
            },
            upgrade() {
                this.$router.push("/subscription-plans");
            },
        },
    }
</script>



<style scoped>

</style>
